import { useLocation, useParams } from "react-router-dom";
import { sessionPersistence } from "@/utils/sessionPersistence";
import { useColonies } from "./useColonies";

export function useColonyContext() {
  const location = useLocation();
  const params = useParams();
  const { colonies, hasColonies } = useColonies();

  const getActiveColonyId = (): string | null => {
    // Ensure colonies is an array to prevent .find() errors
    const safeColonies = colonies || [];
    
    // 1. Check current route for colonyId
    const routeColonyId = params.colonyId;
    if (routeColonyId && safeColonies.find(c => c.id === routeColonyId)) {
      return routeColonyId;
    }

    // 2. Check if we're in a chat route and extract colonyId
    const chatMatch = location.pathname.match(/^\/chat\/([^\/]+)/);
    if (chatMatch) {
      const colonyId = chatMatch[1];
      if (safeColonies.find(c => c.id === colonyId)) {
        return colonyId;
      }
    }

    // 3. Get last active colony from session
    const lastActive = sessionPersistence.getLastActiveColony();
    if (lastActive && safeColonies.find(c => c.id === lastActive)) {
      return lastActive;
    }

    // 4. Fall back to first available colony
    if (hasColonies && safeColonies.length > 0) {
      return safeColonies[0].id;
    }

    return null;
  };

  const activeColonyId = getActiveColonyId();
  const activeColony = activeColonyId ? (colonies || []).find(c => c.id === activeColonyId) : null;

  const setActiveColony = (colonyId: string) => {
    sessionPersistence.setLastActive(colonyId, location.pathname);
  };

  return {
    activeColonyId,
    activeColony,
    setActiveColony,
    hasColonies,
    colonies
  };
}